// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p6-0";
export var animationContainer = "_p6-1";
export var itemPrice = "_p6-a";
export var itemizedContent = "_p6-9";
export var itemizedHeader = "_p6-7";
export var itemizedRow = "_p6-8";
export var itemizedSection = "_p6-6";
export var modalContent = "_p6-2";
export var orderName = "_p6-3";
export var refundOption = "_p6-4";
export var refundOptionsContainer = "_p6-5";
export var shippingLabel = "_p6-b";
export var totalRow = "_p6-c";